import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            焦点深扒
          </h2>
          <p className="text-sm text-foreground-500 font-body">
            深度专题报道，带你了解网红黑料背后的真相与行业乱象
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`group flex flex-col rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 ${
                i === 0 ? 'lg:col-span-2 lg:flex-row' : ''
              }`}
            >
              <div
                className={`relative overflow-hidden shrink-0 ${
                  i === 0
                    ? 'lg:w-1/2 h-48 lg:h-auto'
                    : 'w-full h-40 md:h-48'
                }`}
              >
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-md font-label">
                  {item.tag}
                </span>
              </div>
              <div className={`flex flex-col p-4 md:p-5 gap-3 ${i === 0 ? 'lg:w-1/2' : ''}`}>
                <h3
                  className={`font-heading font-semibold text-foreground-900 leading-snug ${
                    i === 0 ? 'text-base md:text-lg' : 'text-sm md:text-base'
                  }`}
                >
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 font-body leading-relaxed line-clamp-4 flex-1">
                  {item.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap cursor-pointer mt-auto">
                  阅读全文 <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}